/* eslint-disable */
// @TODO refactor this completely, it seems problematic to handle now, lets circle back on it later
import { useCallback, useMemo } from 'react';

import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { Typography } from '@progress/kendo-react-common';

import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { selectDeleteFilter, setDeleteFilter } from '../../store/slices/save-criteria-modals.slice';
import { useDeleteUserDataRowMutation } from '../../store/api/user-data.api';
import {
  selectSavedFiltersEntries,
  setSavedFiltersEntries,
} from '../../store/slices/saved-filters.slice';

export function DeleteCriteriaModal() {
  const [deleteFilter] = useDeleteUserDataRowMutation();

  const currentFilters: any = useAppSelector(selectSavedFiltersEntries);
  const filterKey = useAppSelector(selectDeleteFilter);

  const dispatch = useAppDispatch();

  const closeDialog = useCallback(() => dispatch(setDeleteFilter()), [dispatch]);

  const onDelete = useCallback(async () => {
    if (filterKey !== undefined) {
      const result = await deleteFilter(filterKey);

      if ('data' in result && currentFilters) {
        const newFilters = currentFilters.filter((filter: any): any => filter.key !== filterKey);

        dispatch(setSavedFiltersEntries({ entries: newFilters }));
      }
      closeDialog();
    }
  }, [filterKey, deleteFilter, currentFilters, closeDialog, dispatch]);

  const criteriaName = useMemo((): string => {
    if (filterKey !== undefined && currentFilters) {
      return (
        currentFilters.find((filter: any) => filter.key === filterKey)?.value.name ??
        'Saved Criteria'
      );
    }

    return 'Saved Criteria';
  }, [currentFilters, filterKey]);

  return (
    <>
      {!!filterKey && (
        <Dialog
          className="delete-criteria-dialog"
          title="Delete Saved Search"
          onClose={closeDialog}
        >
          <div className="dialog-content-vertical" style={{ width: '350px' }}>
            <Typography.p textAlign="center">
              Are you sure you want to delete this Saved Search
            </Typography.p>
            <div className="delete-criteria-input">
              <Input value={criteriaName} label="Saved Search Name" disabled />
            </div>
          </div>
          <DialogActionsBar layout="center">
            <Button fillMode="outline" themeColor={'primary'} onClick={closeDialog}>
              Cancel
            </Button>
            <Button themeColor={'primary'} onClick={onDelete}>
              Delete Saved Search
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}
    </>
  );
}
